import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ServiceBookingForm } from './ServiceBookingForm/ServiceBookingForm';
import { getSelectedDoctorObject, getServiceSelected } from './store/selectors';
import { BookingForm } from '../features/bookingForm/BookingForm';
import { bookingFormFields } from '../features/bookingForm/utils';
import { InfoMessage } from '../components/InfoMessage/InfoMessage';
import { PhoneList } from '../components/PhoneList/PhoneList';
import { DoctorServiceBooking } from './DoctorServiceBooking/DoctorServiceBooking';
import { useWidgetProps } from '../WidgetPropsContext';

export const SERVICE_DEBUG = false;

let isDoctorServiceBookingEnabled = true;

export const ServiceBooking = () => {
    const {
        baseUrl, doctorName, serviceId, serviceBranchId, serviceName, specialityName, targetDoctorId,
    } =
    useWidgetProps();
    const {
        branches, services, doctors, timeslot,
    } = useSelector(getServiceSelected);

    const selectedDoctor = useSelector(getSelectedDoctorObject);
    const [ isDoctorServiceBooking, setIsDoctorServiceBooking ] = useState(
        (!!doctorName || !!targetDoctorId) && isDoctorServiceBookingEnabled,
    );
    // const patientData = useState({});
    const { state: { patientData = {} } = {} } = useLocation();
    const isEverythingOk = useCallback(() => {
        return branches && services && doctors && timeslot;
    }, [ branches, services, doctors, timeslot ]);

    const isDoctorOnline = useCallback(() => {
        return selectedDoctor?.online;
    }, [selectedDoctor]);

    useEffect(() => {
        setIsDoctorServiceBooking((!!doctorName || !!targetDoctorId) && isDoctorServiceBookingEnabled);
    }, [ doctorName, targetDoctorId ]);

    return (
        <>
            {isDoctorServiceBooking ? (
                <DoctorServiceBooking
                    targetDoctorId={targetDoctorId}
                    specialityName={specialityName}
                    serviceName={serviceName}
                    serviceId={serviceId}
                    serviceBranchId={serviceBranchId}
                    doctorName={doctorName}
                    baseUrl={baseUrl}
                    onBack={() => {
                        setIsDoctorServiceBooking(false);
                        isDoctorServiceBookingEnabled = false;
                    }}
                />
            ) : (
                <ServiceBookingForm />
            )}
            {/* <ServiceBookingForm/> */}

            {isEverythingOk() ? (
                <>
                    {isDoctorOnline() ? (
                        <BookingForm formName="bookingForm" fields={bookingFormFields} initData={patientData} />
                    ) : (
                        <>
                            <InfoMessage icon="warning">
                                Онлайн-запись к этому врачу ограничена медцентром. Вы можете выбрать время и записаться через звонок в
                                регистратуру.
                            </InfoMessage>
                            <PhoneList label="Номера регистратуры" isService />
                        </>
                    )}
                </>
            ) : null}
            {/* {errorMessage && <div style={{ marginTop: 16 }}><Warning text={errorMessage} show/></div>} */}
        </>
    );
};
